import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Laenderliste from './Laenderliste';

export default function ControllableStates(props) {
    const [selectedCode, setSelectedCode] = useState(null);

    const emptyCountryObject = () => {
      return {
        code: '', 
        label: '', 
        phone: ''
      }
    }

    return (
      <Autocomplete
        id={"AutocompleteLand"+props.label}
        options={
          props.limitEu
          ?Laenderliste("eu")
          :Laenderliste()
        }
        renderInput={params => (
          <TextField 
            {...params}
            label={props.label} 
            required={props.required} 
            error={
              (() => {
                if (!props.required) {
                  return false;
                }
                if (!props.value.code.touched) {
                  return false;
                }
                if (props.value.code.value.length > 1) {
                  return false;
                }
                return true;
              })()
            }
            onBlur = {
              () => props.updaterTouchCode(true)
            }
          />
        )}
        getOptionLabel={
          option => option.hasOwnProperty('labelDe') ? option.de : option.label
        }
        value={selectedCode}
        onChange={
            (_event, countryObject) => {
                let country = countryObject
                if (!country) {
                  country = emptyCountryObject()
                }

                setSelectedCode(countryObject);

                props.updaterValueCode(country.code)

                if (country.hasOwnProperty('de')) {
                  props.updaterValueDe(true)
                } else {
                  props.updaterValueDe(false)
                }
                
                if (country.hasOwnProperty('eu')) {
                  props.updaterValueEu(true)
                } else  {
                  props.updaterValueEu(false)
                }
            }
        }
      />
    );
}
